import request from '../utils/request'
const serviceName = 'admOrg'
import axios from 'axios';

export function getConfigAsync() {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/loginConfig/getList", {})
        .then(response => {
          let result = {};
          if (response && response.data && response.data.rows && response.data.rows.length > 0) {
            result = response.data.rows[0];
          }
          resolve(result);
        })
        .catch(error => {
          reject(error);
          // this.$message.error("数据获取失败");
          console.log("error:" + error.toString());
        });
    });
}

export function asyncMethod(url,data,method) {
  return new Promise((resolve, reject) => {
    axios({
      method: (method||'get'),
      url,
      data
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
        // this.$message.error("数据获取失败");
        console.log("error:" + error.toString());
      });
  });
}

export function saveByEntityName(entityName,options) {
    return request({
      url: `/dftdstore/api/de/record/save?entityName=${entityName}`,
      method: 'post',
      data:options
    })
  }
  export function getEntityNameEdit(option,params) {
    return request({
      url: `/dftdstore/api/de/record/query`,
      method: 'post',
      headers:{
        'Content-Type':'application/json'
      },
      data:option,
      params:params
    })
  }
  export function getEntityName(entityName,data) {
    return request({
      url: `/dftdstore/api/de/record/query/${entityName}`,
      method: 'get',
      params:data
    })
  }

  export function deleteEntityName(options) {
    return request({
      url: `/dftdstore/api/de/record/delete`,
      method: 'delete',
      params:options
    })
  }

  export function getOneEntityName(entityName,id) {
    return request({
      url: `/dftdstore/api/de/record/getByEntityName/${entityName}/${id}`,
      method: 'get',
    })
  }



// WEBPACK FOOTER //
// ./src/api/modularMain.js